import { useEffect, useState } from 'react';
import { withFormik } from 'formik';
import _isEmpty from 'lodash/isEmpty';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams, useHistory } from 'react-router-dom';
import { VERSIONS } from 'constants/versions';
import { Modal } from 'components';
import GiftsList from 'components/gifts-table/GiftsList';
import GiftsFilter from 'components/gifts-table/GiftsList/GiftsFilter';
import { getProductsById } from 'services/api/products';
import TableWelcomeMessage from 'components/gifts-table/TableWelcomeMessage';
import { GiftItem, TableHero } from 'components/gifts-table';
import { fetchGiftTableInfo } from 'store/actions/giftTable';
import { resetExternalGiftTable } from 'store/actions/externalGiftTable';
import ClosedTableMessage from 'components/gifts-table/ClosedTableMessage';
import { MODES } from 'components/gifts-table/GiftsList/GiftItem/config';
import { isTableOpen } from 'util/giftTable';
import { showErrorResponseModal } from 'store/actions/commons';
import styles from './styles.module.scss';
import _get from "lodash/get";
import Flujo from './MyGuests';
const mapPropsToValues = ({ selectedCategory = {}, giftParams = {} }) => ({
  selectedCategory: selectedCategory.id || '',
  filterCategory: giftParams.category || 'Sugerencias'
});
import MyGuests from 'pages/TableAdmin/MyGuests/MyGuests';
import {infotabla} from 'services/rsvp/getRSVP';
import { hideLoader, showLoader } from 'store/actions/commons';
import { useWindowSize } from 'hooks';
function RsvpLanding({
  dispatch,
  tableInfo,
  externalGiftTableProducts,
  shoppingCartProducts,
  fetchExternalGiftTableProducts,
  addShoppingCartProduct,
  removeShoppingCartProduct,
  changeProductsPage,
  fetchShoppingCart,
}) {
  const { eventId } = useParams();
  const history = useHistory();
  const [showProduct, setShowProduct] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const { isMobile } = useWindowSize({ largeMobile: true })[1];
 // const [, dispatch] = useStore((state) => state.giftTable.giftTable);
  /*const [giftTableProduct, setGiftTableProduct] = useState({});
  const [productosid, setProductosid] = useState([]);
  const [brands, setBrands] = useState([]);
  const [listaProduct,setListaProduct] = useState('');
  const [loading, setLoading] = useState(true);*/

  /*
  useEffect(() => {
    // if (!eventId) history.push('/');
  }, [eventId, history]); */

  console.log("+++++++++++++++++++++++++++++")
  console.log(tableInfo)
  console.log("+++++++++++++++++++++++++++++")

  /* VALIDA SI YA TIENE UNA INVITACION CREADA */
  const [invitation, setInvitation] = useState(false);
  console.log('RSVP v 1.1');

  useEffect(() => {
    console.log('tableInfo useEfect',tableInfo)
    if(tableInfo?.evento != undefined){
      infotabla(tableInfo?.evento).then((valorDeServicio) => {
        console.log('infotabla hay invitacion ', valorDeServicio);
        if(valorDeServicio == false ){
          setInvitation(false)
        }else{
          setInvitation(true)
        }
        //valorDeServicio ? setInvitation(true) : setInvitation(false);
        dispatch(hideLoader());
      });
    }

  },[tableInfo]);

  useEffect(() => {
    dispatch(showLoader());
    window.scrollTo(0, 0); // Esto hace que la página se desplace al principio
  }, [])

  return (
    <section className={styles.TableAdmin}>
      <TableHero
        image={tableInfo?.image}
        typeId={tableInfo?.type?.id}
        eventName={tableInfo?.type?.name}
        name={tableInfo?.name}
        date={tableInfo?.date}
        readOnly
        custom={ isMobile && true}
      />
      <Container>
      <div className="container">
        {invitation ? <MyGuests typeId={tableInfo?.evento}/> : <Flujo typeId={tableInfo?.evento}/>}
      </div>
      </Container>

    </section>
  );
}

export default withFormik({ mapPropsToValues })(RsvpLanding);
